import React, { createContext, useContext, useState, useCallback } from 'react';

const EnrollmentContext = createContext();

export const useEnrollment = () => {
  const context = useContext(EnrollmentContext);
  if (!context) {
    throw new Error('useEnrollment must be used within an EnrollmentProvider');
  }
  return context;
};

export const EnrollmentProvider = ({ children }) => {
  const [enrollmentVersion, setEnrollmentVersion] = useState(0);
  const [lastEnrollmentUpdate, setLastEnrollmentUpdate] = useState(null);

  // Trigger a refresh of enrollment data across all components
  const triggerEnrollmentRefresh = useCallback(() => {
    setEnrollmentVersion(prev => prev + 1);
    setLastEnrollmentUpdate(new Date().toISOString());
    // console.log('📊 Triggering enrollment data refresh across components');
  }, []);

  // Mark that a new enrollment has occurred
  const markNewEnrollment = useCallback((courseInfo) => {
    triggerEnrollmentRefresh();
    // console.log('✅ New enrollment recorded:', courseInfo);
  }, [triggerEnrollmentRefresh]);

  const value = {
    enrollmentVersion,
    lastEnrollmentUpdate,
    triggerEnrollmentRefresh,
    markNewEnrollment
  };

  return (
    <EnrollmentContext.Provider value={value}>
      {children}
    </EnrollmentContext.Provider>
  );
};

export default EnrollmentContext;